import { map } from "@/mono/lib/math";
import { isIOS, isMobile } from "@/mono/lib/platform";
import { isMobileLayout } from "@/mono/lib/responsive";
import { breakpointDesktopLarge } from "@/mono/lib/styles/vars";
import { create } from "zustand";

const useGlobalStore = create((set, get) => ({
  noWebGLImages: true,

  isDebug: false,
  skipIntro: false,

  isReady: false,
  isLoading: true,

  lenis: null,

  urlQuery: null,
  isFirstLoad: true,

  // TODO: move to device store
  isMobile: isMobile(),
  isMobileLayout: false,
  isTabletOnlyLayout: false,
  isTabletOrSmallerLayout: false,

  isIOS: isIOS(),

  gpuDetect: null,
  quality: "low",
  dpr: 1,
  supportOffScreenCanvas: false,

  // Save in store and use this as main value to avoid re-calculations
  // when querying window.innerWidth / window.innerHeight
  windowSize: { width: 0, height: 0 },
  hasDimensions: () => {
    const { windowSize } = get();
    return windowSize.width !== 0 && windowSize.height !== 0;
  },

  screenWidthMultiplier: ({ min = 0.25, max = 1 } = {}) => {
    return map(
      get().windowSize.width,
      0,
      breakpointDesktopLarge,
      min,
      max,
      true
    );
  },
}));

export { useGlobalStore };
